var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 90,
    viewBox: "0 0 128 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 89.2396V59.1284C0 35.9286 9.96717 14.5632 17.2134 11.1967C49.5 -3.8034 77 -3.80337 111.257 11.6282C120.224 15.6678 128 45.1282 128 59.1284V89.2396C126.847 88.3944 125.503 87.7656 123.948 87.3929C123.983 86.0451 124 84.6827 124 83.3062C124 36.9238 104.169 12 64 12C23.8312 12 4 36.9238 4 83.3062C4 84.6827 4.01747 86.0451 4.05241 87.3929C2.49732 87.7656 1.15329 88.3944 0 89.2396Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6084 18.9937C81.0702 24.1601 47.787 24.508 33.0652 18.9937C27.515 16.9147 44.502 5.99999 64.3458 6C75.95 6 101.176 15.8753 93.6084 18.9937Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0303 9.93923C40.3694 29.5125 45.6798 44.9031 59.7026 49.808C60.7453 50.1727 61.8557 49.5077 62.1413 48.4407C70.9299 15.6074 70.6814 14.7586 47.4633 8.52059C46.3966 8.23399 45.2862 8.8647 45.0303 9.93923Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1084 9.93923C89.7692 29.5125 84.4589 44.9031 70.436 49.808C69.3934 50.1727 68.283 49.5077 67.9974 48.4407C59.2088 15.6074 59.4572 14.7586 82.6753 8.52059C83.7421 8.23399 84.8525 8.8647 85.1084 9.93923Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7888 8.94176C103.714 25.7469 99.165 38.9686 87.2001 43.3094C86.1618 43.6861 85.052 43.0254 84.7664 41.9584C77.2139 13.7331 77.4546 12.8746 97.3671 7.5188C98.4337 7.2319 99.5375 7.86614 99.7888 8.94176Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3839 8.75077C25.6366 23.282 26.5604 36.5981 36.4865 43.5898C37.3895 44.2259 38.6318 43.8761 39.1837 42.9193C53.1258 18.75 53.1183 17.857 36.0881 8.00069C35.1321 7.4474 33.9036 7.77607 33.3839 8.75077Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair2);
export default __webpack_public_path__ + "static/media/Hair 2.353441967a7b2c5c0e795220f68d49b3.svg";
export { ForwardRef as ReactComponent };